/* eslint-disable */
import type { AxiosResponse } from "axios";
import SpaToolsApiClient from "./base/SpaToolsApiClient";

export type Property = {
    id: number;
    name: string;
    titleInDropdown: string | null;
};

export type GetPropertyListResponse = {
    properties: Property[];
};

export type FAQItem = {
    Answer: string;
    AnswerId: number;
    Category: string;
    DefaultAnswer: string;
    IsDefaultValue: boolean;
    ProperyId: number;
    Question: string;
    QuestionId: number;
    Subject: string;
}

export type GetFAQsResponse = {
    faqs: FAQItem[][];
    isWriteMode: boolean;
};

export type SaveQuestionsResponse = {
    status: string;
};

export default class FaqApiClient extends SpaToolsApiClient {

    async getPropertyListAsync(): Promise<AxiosResponse<GetPropertyListResponse>> {
        return this.get(`/GetPtopertyList`);
    }
    
    
    async getFAQs(propertyId: string): Promise<GetFAQsResponse> {
        const authToken = window.localStorage.getItem("auth_token");
        const parsed = JSON.parse(authToken);
        const email =  parsed.email || "";

        const res = await this.get(`/GetFAQs?propertyId=${propertyId}&userEmail=${email}`);
        let faqs: FAQItem[][] = [];
        if (res.data && typeof res.data.group === 'string') {
            try {
                faqs = JSON.parse(res.data.group);
            } catch (e) {
                faqs = [];
            }
        }
        return {
            faqs,
            isWriteMode: res.data.isWriteMode,
        };
    }


    async saveQuestions(data: FAQItem[]): Promise<SaveQuestionsResponse> {
        const res = await this.post(`/SaveQuestions`, data);
        return res.data;
    }
}